// Central RunSignup config. Update RUNSIGNUP_URL here and every CTA on the
// site will point to the correct place.
export const RUNSIGNUP_URL = "https://runsignup.com/Race/Events/NC/Concord/RunToEmpowerEntrepreneurs5KMileFunRun";

// Registration & checkout are handled entirely on RunSignup — no built-in
// checkout on this site.
export const RUNSIGNUP_DEEP_LINKS = {
  register: RUNSIGNUP_URL,
  register5K: RUNSIGNUP_URL,
  register1Mile: RUNSIGNUP_URL,
  team: `${RUNSIGNUP_URL}?tab=teams`,
  donate: `${RUNSIGNUP_URL}?tab=donations`,
};

export const goToRunSignup = (target = "register") => {
  const url = RUNSIGNUP_DEEP_LINKS[target] || RUNSIGNUP_URL;
  window.open(url, "_blank", "noopener,noreferrer");
};

// Full pricing table (display only — actual charges happen on RunSignup)
export const PRICING_TABLE = {
  "5k": {
    label: "5K Run/Walk",
    tiers: [
      { key: "early_bird", label: "Early Bird", dates: "Now – Sept 22, 2026", base: 20, withShirt: 32, plusSize: 34 },
      { key: "standard", label: "Standard Pricing", dates: "Sept 23 – Oct 27, 2026", base: 25, withShirt: 37, plusSize: 39 },
      { key: "regular", label: "Regular / Late Pricing", dates: "Oct 28, 2026 – Race Day", base: 35, withShirt: 47, plusSize: 49 },
    ],
  },
  "1mile": {
    label: "1-Mile Fun Run",
    tiers: [
      { key: "early_bird", label: "Early Bird", dates: "Now – Sept 22, 2026", base: 10, withShirt: 22, plusSize: 24 },
      { key: "standard", label: "Standard Pricing", dates: "Sept 23 – Oct 27, 2026", base: 15, withShirt: 27, plusSize: 29 },
      { key: "regular", label: "Regular / Late Pricing", dates: "Oct 28, 2026 – Race Day", base: 20, withShirt: 32, plusSize: 34 },
    ],
  },
};

export const SHIRT_INFO = {
  youthToXL: 12,
  plusSize: 14,
  deadline: "October 16, 2026",
};

// Fundraising goal
export const FUNDRAISING_GOAL = 5000;
